// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { ClarityService } from './services/clarity/clarityService'
import { GetuAttributionService } from './services/attribution'
import './assets/styles/main.css'
import './assets/styles/components/modal.css'
import './assets/styles/components/editor.css'
import './assets/styles/pages/prompts.css'
import './assets/styles/pages/content.css'
import './assets/styles/pages/library.css'
import './assets/styles/pages/skills.css'
import './assets/styles/pages/setup.css'
import './assets/styles/pages/landing.css'
import './assets/styles/pages/pricing.css'

// Initialize SDKs
ClarityService.initOnce()
GetuAttributionService.initOnce()

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>,
)
